import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiCheck } from 'react-icons/fi';
import './About.css';

function About() {
  const { t } = useTranslation();
  
  const engagements = [
    { textKey: 'about.technicalText', subtitleKey: 'about.technical' },
    { textKey: 'about.simplicityText', subtitleKey: 'about.simplicity' },
    { textKey: 'about.brandingText', subtitleKey: 'about.branding' },
    { textKey: 'about.complianceText', subtitleKey: 'about.compliance' }
  ];

  return (
    <section id="apropos" className="about section">
      <div className="container">
        <div className="about-grid">
          <div className="about-content">
            <h2 className="section-title about-section-title">{t('about.title')}</h2>
            <p className="section-quick-answer section-quick-answer--left">{t('about.quickAnswer')}</p>
            <p className="about-text">
              {t('about.description')}
            </p>
            <div className="engagements-list">
              {engagements.map((engagement, index) => (
                <div key={index} className="engagement-item">
                  <div className="engagement-icon">
                    <FiCheck />
                  </div>
                  <div className="engagement-content">
                    <strong>{t(engagement.subtitleKey)} :</strong> {t(engagement.textKey)}
                  </div>
                </div>
              ))}
            </div>
            <p className="about-learn-more">
              <Link to="/a-propos/">{t('about.learnMore')}</Link>
            </p>
          </div>
          <div className="about-image">
            <div className="image-placeholder"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;


